import "react-s-alert/dist/s-alert-default.css";
import ToastService from "react-material-toast";
import path from "path";

const toast = ToastService.new({
    place: "topRight",
    duration: 1,
    maxCount: 2,
});
// const cookies = new Cookies();
const utility = {
    apiFailureToast,
    apiSuccessToast,
    validateName,
    validateEmail,
    isPasswordValid,
    parseResponse,
    isMenuActive,
    getFileName,
    getNewFileName,
    decodeBase64Key,
    isEmpty,
    isEmptyArray,
    getMediaURL,

};
export default utility;

/**
 *              This function is made to handle success and error callback!
 * @param promise
 * @returns {Promise<Promise|Bluebird<*[] | R>|Bluebird<any | R>|*|Promise<T | *[]>>}
 */
function parseResponse(promise) {
    return promise
        .then((data) => {
            return [null, data];
        })
        .catch((err) => [err]);
}

export const dispatchAction = (type, data) => {
    return (dispatch) => dispatch({type, data});
};

//TODO: update apiConstant.API_FAILURE
function apiFailureToast(message) {
    toast.error(message ? message : "apiConstant.API_FAILURE");
}

function apiSuccessToast(msg) {
    toast.success(msg ? msg : "apiConstant.API_SUCCESS");
}

function validateName(name) {
    let reg = /[A-Z][a-zA-Z]*/;
    return reg.test(name);
}

function validateEmail(email) {
    let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(email);
}

function isPasswordValid(password) {
    // let reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
    // return reg.test(password);
}

function isMenuActive(path) {
    return window.location.pathname.includes(path);
}

function getFileName(fileName) {
    let extension = path.extname(fileName);
    let baseName = path.basename(fileName, extension);
    return {baseName, extension}
}

function getNewFileName(baseName, extension) {
    let fileName = `${baseName}_${(new Date()).getTime()}${extension}`;
    return fileName.replace(/ /g, "_");
}

function decodeBase64Key(name) {
    if (!name || !name.length)
        return "";

    return new Buffer(name, 'base64').toString('ascii');
}

function isEmpty(string) {
    return !string || string.trim().length === 0;
}

function isEmptyArray(array) {
    return !array || array.length === 0;
}

function getMediaURL(fileName) {
    return `https://gold-work-dev.s3.amazonaws.com/${fileName}`
}

